import type { RequestPolicy } from 'urql';

import { useIsLoggedIn } from '@order/AuthMachine';
import { useGetSweetpassTierQuery } from '@order/graphql';
import { useFeatureFlag } from '@order/LaunchDarkly';

export const useSweetpassTier = (
  requestPolicy: RequestPolicy = 'cache-only',
) => {
  const isSweetpassEnabled = useFeatureFlag('OPS-sweetpass-enabled', {
    listenForChanges: true,
  });

  const isLoggedIn = useIsLoggedIn();

  const [sweetpassTierResponse, refetchSweetpassTier] =
    useGetSweetpassTierQuery({
      requestPolicy,
      pause: !isSweetpassEnabled || !isLoggedIn,
    });

  const isSweetpassTierLoading = sweetpassTierResponse?.fetching;

  const sweetpassTier = sweetpassTierResponse?.data?.loyaltyProfile?.tier;
  const sweetpassTierName = sweetpassTier?.name;

  const sweetpassNextTier =
    sweetpassTierResponse?.data?.loyaltyProfile?.tier?.nextTier;
  const sweetpassNextTierId = sweetpassNextTier?.id;
  const sweetpassNextTierName = sweetpassNextTier?.name;

  const joinDate = sweetpassTierResponse?.data?.loyaltyProfile?.joinDate;

  return {
    joinDate,
    sweetpassTierName,
    sweetpassNextTierId,
    sweetpassNextTierName,
    isSweetpassEnabled,
    isSweetpassTierLoading,
    refetchSweetpassTier,
  };
};
